/**
 * Check if a listing is in user's favorites list.
 */
export const isListingFavourite = ({ currentUser, listing }) => {
  const favouriteListings =
    currentUser?.attributes?.profile?.protectedData?.favouriteListings || [];
  return favouriteListings.indexOf(listing?.id?.uuid) >= 0;
};

/**
 * Get array of favourite listing IDs from user profile.
 */
export const getFavouriteListingIds = user =>
  user?.attributes?.profile?.protectedData?.favouriteListings || [];
